import { Component } from "react";

export interface ErrorBoundaryProps {
  className?: string;
  style?: any;
  children: any;
  errorMessage?: string;
}

export interface ErrorBoundaryState {
  error?: any;
  errorInfo?: any;
}

class ErrorBoundary extends Component<ErrorBoundaryProps, ErrorBoundaryState> {
  constructor(props) {
    super(props);

    this.state = { error: undefined };
  }

  componentDidCatch(error, info) {
    this.setState({ errorInfo: info });
  }

  static getDerivedStateFromError(error) {
    // Update state so the next render will show the fallback UI.
    return { error: error };
  }

  render() {
    const { children = null, errorMessage = "An error occurred." } = this.props;

    if (this.state.error) {
      // Error path
      return (
        <div className="container">
          <div className="m-3 alert alert-danger">
            <p>
              <strong>{errorMessage}</strong>
            </p>

            {process.env.NODE_ENV === "development" && (
              <>
                <p>
                  <strong>
                    <em>
                      Check the browser's console for detailed stack track.
                    </em>
                  </strong>
                </p>

                <details className="pre-wrap" open>
                  {this.state.error && this.state.error.toString()}
                  {this.state.errorInfo && this.state.errorInfo.componentStack}
                  <br />
                  <br />
                  {this.state.error && this.state.error.stack}
                </details>
              </>
            )}
          </div>
        </div>
      );
    }

    // Normally, just render children
    return children;
  }
}

export default ErrorBoundary;
